import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "style1" }
const _hoisted_2 = { style: {"width":"350px","margin-top":"-150px"} }
const _hoisted_3 = { class: "style4" }

export function render(_ctx, _cache) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")
  const _component_el_tabs = _resolveComponent("el-tabs")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_row = _resolveComponent("el-row")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, {
      style: {"height":"100%","width":"100%"},
      type: "flex",
      class: "row-bg",
      align: "middle",
      justify: "center"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { style: {"text-align":"center"} }, [
            _createElementVNode("div", { class: "style2" }, " 旅行精灵后台 "),
            _createElementVNode("div", { class: "style3" }, " 旅行精灵 backend management system ")
          ], -1)),
          _createVNode(_component_el_tabs, {
            modelValue: _ctx.loginData.type,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.loginData.type) = $event)),
            style: {"margin-top":"50px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_tab_pane, {
                label: "密码登录",
                name: "0"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "style5" }, " 账号 ", -1)),
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.loginData.account,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.loginData.account) = $event)),
                      placeholder: "请输入登录账号",
                      clearable: ""
                    }, null, 8, ["modelValue"]),
                    _cache[5] || (_cache[5] = _createElementVNode("div", {
                      class: "style5",
                      style: {"margin-top":"20px"}
                    }, " 密码 ", -1)),
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.loginData.password,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.loginData.password) = $event)),
                      placeholder: "请输入密码",
                      "show-password": "",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_button, {
            loading: _ctx.isLogin,
            onClick: _cache[3] || (_cache[3] = $event => (_ctx.login())),
            style: {"width":"100%","margin-top":"20px"},
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.isLogin ? '登录中' : '登录'), 1)
            ]),
            _: 1
          }, 8, ["loading"]),
          _cache[7] || (_cache[7] = _createElementVNode("div", { style: {"color":"gray","font-size":"14px","margin-top":"20px"} }, " Copyright 2024 ©旅行精灵后台管理系统 ", -1))
        ])
      ]),
      _: 1
    })
  ]))
}